export default __webpack_public_path__ + "static/media/learose-2048w.b3ca8622.webp";